import React from "react";
import { FormControlLabel, Switch } from "@material-ui/core";
import { BrowserRouter as Router, Link } from "react-router-dom";

const Header = ({ onSwitch }) => {
  return (
    <header className="text-center">
      <nav className="navbar">
        <ul className="w-100">
          <li>
            <Link to="/">Home</Link>
          </li>

          <li>
            <Link to="/about">About Me</Link>
          </li>

          <li>
            <Link to="/works">Works</Link>
          </li>

          <li>
            <Link to="/contact">Contact Me</Link>
          </li>

          <li>
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  color="default"
                  onChange={(e) => onSwitch(e)}
                />
              }
            />
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
